import React from 'react'

import FavoriteTutor from './FavoriteTutor'

import { topTutors } from '../../../../constants'

const FavoriteTutorsContent = () => {
  const tutorsContent = topTutors.map((tutor) => {
    return <FavoriteTutor key={tutor.id} tutor={tutor} />
  })

  return (
    <div className="w-full p-[16px] pb-[24px] flex flex-col items-center justify-start max-h-[600px] overflow-y-auto primary-scroll">
      <div className="w-full flex flex-col gap-y-[12px]">{tutorsContent}</div>
    </div>
  )
}

export default FavoriteTutorsContent
